import MenuStore from "@retailer/svelte/stores/MenuStore";
import MenuItemStore from "@retailer/svelte/stores/MenuItemStore";
import FeatureMenuStore from "@retailer/svelte/stores/FeatureMenuStore";
import { HttpPromise } from "@shared/svelte/Modules/ApiService";

export const setMenuItems = function (path) {
  HttpPromise({
    method: "GET",
    url: `/api/${path}/navigation_menus`,
  }).then(function (res) {
    MenuStore.update(n => {
      return res;
    });
  });

  const menuItemsPath =
    path === "retailer"
      ? "/api/retailer/navigation_menu_items"
      : "/api/demo/navigation_menus/items";
  HttpPromise({
    method: "GET",
    url: menuItemsPath,
  }).then(function (res) {
    MenuItemStore.update(n => {
      return res;
    });
  });

  HttpPromise({
    method: "GET",
    url: `api/${path}/navigation_menus/features`,
  }).then(function (res) {
    FeatureMenuStore.update(n => {
      return res;
    });
  });
};
